<template>
  <div>
    <Header />
    <Body />
    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
/*componenti*/
import Header from '@/components/views/Header.vue'
import Body from '@/components/views/Home.vue'
import Footer from '@/components/views/Footer.vue'

export default {
  name: 'HomePage',
  components: {
    Header,
    Body,
    Footer
  },
  /*
  constants: {
    HTMLTITLE: 'SCTOutil.VDA',
    NODE_ENV: process.env.NODE_ENV
  },
  data() {
      return {
        tipoutilizzo:'auth',
        pageGA:'/default/adesione',
      }},
  */
}
</script>
